<template>
  <div class="dh-psy-memorial">
    <div class="dh-psy-memorial__text">
      <p>Sønnen, Preben (28), er psykisk syk og lagt inn på lukket avdeling.</p>
      <p>Sønnen, Preben (28), er psykisk syk og lagt inn på lukket avdeling.</p>
    </div>
    <div class="dh-psy-memorial__img">
      <RegularImage :imageId="id" :aspect="aspect" :inline="true" :reset="true" />
    </div>
  </div>
</template>

<script>
import RegularImage from '../../Media/Images/Regular.vue'
export default {
  data() {
    return {
      id: '1.14281159',
      aspect: 'F34'
    }
  },
  components: {
    RegularImage
  }
}
</script>

<style scoped lang="postcss">
  .dh-psy-memorial {
    display: flex;
    width: 100%;
    max-width: 1500px;
    margin: auto;
  }

  .dh-psy-memorial__text {
    margin: 0 auto calc(500px * 1.33 * 0.5);

    & p {
      margin: 20vh auto 0;
      margin-top: calc(500px * 1.33 * 0.5);
    }
  }

  .dh-psy-memorial__img {
    @media (min-width: 900px) {
      width: 50%;
      max-width: 50%;
      position: sticky;
      height: calc(500px * 1.33);
      top: calc(500px * 1.33 * 0.5);

      & > div {
        width: 500px;
        margin: auto;
      }
    }
  }
</style>
